import { useState } from "react";
import { motion } from "framer-motion";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
} from "@nextui-org/react";
import data from "../../data/index.json";
import BlurImage from "../../components/BlurImage";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-50px" },
};

export default function Certificates() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedCert, setSelectedCert] = useState(null);

  return (
    <section id="Certificates" className="section-padding bg-gray-50 dark:bg-black/50">
      <div className="section-container">
        <motion.div {...fadeUp} className="text-center mb-16">
          <h2 className="section-title">Certificates</h2>
          <p className="section-subtitle mx-auto">
            Professional certifications and achievements
          </p>
        </motion.div>

        <motion.div
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          transition={{ staggerChildren: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {data?.testimonial?.map((item, index) => (
            <motion.div
              key={item.id || index}
              variants={{
                initial: { opacity: 0, y: 20 },
                whileInView: { opacity: 1, y: 0 },
              }}
              className="bento-glass-card cursor-pointer"
              onClick={() => {
                setSelectedCert(item);
                onOpen();
              }}
            >
              <div className="rounded-xl overflow-hidden mb-4 aspect-[4/3]">
                <BlurImage
                  src={item.src}
                  alt={item.title || `Certificate ${index + 1}`}
                  className="w-full h-full transition-transform duration-300 hover:scale-105"
                />
              </div>
              {item.title && (
                <h3 className="font-display text-base font-bold text-black dark:text-white">
                  {item.title}
                </h3>
              )}
              {item.issuer && (
                <p className="font-body text-sm text-black/50 dark:text-white/50 mt-1">
                  {item.issuer}
                </p>
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="3xl"
        placement="center"
        classNames={{
          base: "bg-white/95 dark:bg-black/95 backdrop-blur-2xl border border-black/10 dark:border-white/10",
          closeButton: "hover:bg-black/10 dark:hover:bg-white/10",
        }}
      >
        <ModalContent>
          {() => (
            <>
              <ModalHeader className="font-display text-xl font-bold text-black dark:text-white">
                {selectedCert?.title || "Certificate"}
              </ModalHeader>
              <ModalBody className="pb-6">
                <div className="rounded-xl overflow-hidden">
                  <img
                    src={selectedCert?.src}
                    alt={selectedCert?.title || "Certificate"}
                    className="w-full h-auto object-contain"
                  />
                </div>
                {selectedCert?.issuer && (
                  <p className="font-body text-sm text-black/50 dark:text-white/50 mt-2">
                    {selectedCert.issuer}
                  </p>
                )}
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </section>
  );
}
